import './styles.css';
import './ui/theme';
import { createRoot } from 'react-dom/client';
import { App } from './ui/AppShell';
import { WorkspaceStore } from './domain/store';

const host = document.getElementById('app');
if (!host) throw new Error('#app fehlt in index.html');

createRoot(host).render(<App store={WorkspaceStore.restore()} />);
